import {
  getDebtorAddressFields,
  debtorEmailFields,
  debtorEmployerFields,
  debtorMilitaryFields,
  debtorPhoneFields,
  getConsumerDebtorFields,
  debtorBankruptcyFields,
} from "integrations/dromo/debtorSchemaFields";
import { DROMO_DATE_FORMAT } from "integrations/dromo/dromoFormats";

export default [
  {
    key: "debtor_external_id",
    label: "Debtor External ID",
    type: "string",
    validators: [{ validate: "required" }],
  },
  ...getConsumerDebtorFields(),
  {
    // Placing this here instead of in getConsumerDebtorFields() because it is not supported during account upload flow (yet).
    // We'll need to move it to the getConsumerDebtorFields() function when we add support for it.
    key: "debtor_deceased_date",
    label: "Debtor Deceased Date",
    type: DROMO_DATE_FORMAT,
  },
  ...debtorEmailFields,
  ...getDebtorAddressFields(),
  ...debtorPhoneFields,
  ...debtorEmployerFields,
  ...debtorMilitaryFields,
  ...debtorBankruptcyFields,
];
